exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__View__view__12yiC {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.dmb-web__View__view__12yiC:not(:last-child) {\n  border-left: 2px solid black;\n}\n", ""]);

// exports
exports.locals = {
	"view": "dmb-web__View__view__12yiC"
};